import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactSVG } from "react-svg";

import MessagesListItem from "./Item";
import { useCookies } from "react-cookie";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Switch from "../../../UI/Switch/index";

import { SET_CHAT_FEATURES } from "../../../../redux/action/messages/chat/chatType";
import { getSessions } from "../../../../redux/action/messages/list/listAction";

const MessagesListBot = () => {
  const dispatch = useDispatch();
  const sessions = useSelector((state) => state.messages.list.sessions);

  const loaded = useSelector((state) => state.messages.list.loadedSessions);

  const loading = useSelector((state) => state.messages.list.loadingSessions);
  const error = useSelector((state) => state.messages.list.errorSessions);

  const navigate = useNavigate();

  const featuresMessages = useSelector((state) => state.messages.chat.features);

  const [cookies, , removeCookie] = useCookies(["authToken"]);
  const [searchParams] = useSearchParams();
  const chatSession = searchParams.get("session_id");

  // page conection
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (sessions.length <= 0 && !loading && !loaded) {
      getSessionsList();
      const date = new Date();
      localStorage.setItem("last_load_messages", date.getTime());
    }
    setFeaturesSessions();
  }, [chatSession]);

  useEffect(() => {
    if (error) {
      if (error === "ابتدا وارد حساب کاربری خود شوید.") {
        // come go to authPage and remove cookies
        removeCookie("authToken");

        navigate("/auth/login", { replace: true });
      }
    }
  }, [error]);

  const setFeaturesSessions = async () => {
    const item = sessions?.data?.find((item) => item.id == chatSession);
    let featuresSessions = [];
    if (item?.features) {
      try {
        featuresSessions = JSON.parse(item.features);
        if (!Array.isArray(featuresSessions)) {
          featuresSessions = [];
        }
      } catch (e) {
        featuresSessions = [];
      }
    }
    await dispatch({
      type: SET_CHAT_FEATURES,
      payload: featuresSessions,
    });
  };

  const getSessionsList = async () => {
    await dispatch(await getSessions(cookies.authToken));
  };

  const updateFeaturesField = async (value, name) => {
    const check = featuresMessages.includes(name);
    let newFeatures = [];
    if (check) {
      newFeatures = featuresMessages.filter((item) => item !== name);
    } else {
      newFeatures = [...featuresMessages, name];
    }

    await dispatch({
      type: SET_CHAT_FEATURES,
      payload: newFeatures,
    });
  };

  const handleScroll = (e) => {
    const el = e.target;
    const scrollTop = el.scrollTop;
    const clientHeight = el.clientHeight;
    const scrollHeight = el.scrollHeight;

    const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);

    if (distanceFromBottom < 50) {
      loadMoreSessions();
    }
  };

  const loadMoreSessions = async () => {
    if (isFetchingMore) return;
    if (!sessions.pagination?.has_more_pages) return;
    setIsFetchingMore(true);
    const nextPage = page + 1;
    const success = await dispatch(getSessions(cookies.authToken, nextPage));
    if (success) {
      setPage(nextPage);
    }
    setIsFetchingMore(false);
  };

  // ====== Render ======

  if (loading) {
    return (
      <section className="flex items-center justify-center h-20">
        <ReactSVG
          src="../assets/images/icons/loading-dot.svg"
          className="w-10 text-second"
        />
      </section>
    );
  }

  if (error) {
    return (
      <section className="flex items-center gap-2">
        <ReactSVG
          src="../assets/images/icons/info-box.svg"
          className="w-6 text-rose-500"
        />

        <p className="text-gray-700 leading-7"> {error} </p>
      </section>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <Link
        to={`/`}
        className="flex w-full bg-gray-100 p-3 shadow-custom-sm rounded-xl gap-3 border border-gray-100"
      >
        <div className="flex items-center w-full gap-2">
          <ReactSVG
            className="w-7"
            src={`${process.env.PUBLIC_URL}/assets/images/icons/edit-3.svg`}
          />

          <div className="flex items-center justify-between w-full">
            <span> ساخت گفتگو جدید </span>
          </div>
        </div>
      </Link>

      <div className="flex flex-col gap-3">
        <div class="flex items-center w-full">
          <p class="whitespace-nowrap p-2 text-sm">ویژگی ها</p>
          <span class="ml-3 h-px flex-1 bg-gray-200"></span>
        </div>
        <Switch
          name={"مشاوره قراردادی"}
          list={true}
          title={"مشاوره قراردادی"}
          value={
            featuresMessages.find((item) => item === "مشاوره قراردادی")
              ? true
              : false
          }
          onUpdateSwitchValue={updateFeaturesField}
        />
        <Switch
          name={"نوشتن قرارداد"}
          list={true}
          title={"نوشتن قرارداد"}
          value={
            featuresMessages.find((item) => item === "نوشتن قرارداد")
              ? true
              : false
          }
          onUpdateSwitchValue={updateFeaturesField}
        />
        <Switch
          name={"بررسی حقوقی"}
          list={true}
          title={"بررسی حقوقی"}
          value={
            featuresMessages.find((item) => item === "بررسی حقوقی")
              ? true
              : false
          }
          onUpdateSwitchValue={updateFeaturesField}
        />
        <Switch
          name={"حقوق ملکی"}
          list={true}
          title={"حقوق ملکی"}
          value={
            featuresMessages.find((item) => item === "حقوق ملکی") ? true : false
          }
          onUpdateSwitchValue={updateFeaturesField}
        />
      </div>

      <div class="flex items-center w-full">
        <p class="whitespace-nowrap p-2 text-sm">گفتگو ها</p>
        <span class="ml-3 h-px flex-1 bg-gray-200"></span>
      </div>

      <div
        id="sessionsScrollContainer"
        onScroll={handleScroll}
        style={{ height: "calc(100vh - 460px)", overflowY: "auto" }}
        className="flex flex-col gap-3 pb-3"
      >
        {sessions?.data?.length > 0 ? (
          sessions.data.map((item) => (
            <MessagesListItem key={item.id} message={item} />
          ))
        ) : (
          <p className="text-center py-3 text-gray-500">گفتگویی یافت نشد !</p>
        )}

        {loading && (
          <p className="text-center py-3 text-gray-500">در حال بارگذاری...</p>
        )}
      </div>
    </div>
  );
};

export default MessagesListBot;
